import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import "react-photo-view/dist/react-photo-view.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import AuthProvider from "./context/AuthProvider";
import Aos from 'aos';
import 'aos/dist/aos.css';


// Aos initialization
Aos.init();

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      
        <App />
      
    </QueryClientProvider>
  </React.StrictMode>
);

